<div class="user-menu" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <div class="__account" *ngIf="account" (click)="toggleUserMenu()">
    <span *ngIf="isImpersonated" class="impersonated"> You are logged in as </span>

    <div class="avatar">
      {{ account.initials }}
    </div>

    <span class="name">
      {{ account.name }}
    </span>

    <span class="title">
      {{ camelToLabel(account.title) }}
    </span>
  </div>

  <button
    [class.hidden]="isImpersonated"
    class="expand-icon fake-mat-icon-button"
    (click)="toggleUserMenu()">
    <mat-icon>{{ isUserMenuOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
  </button>

  <button [class.hidden]="!isImpersonated" class="inline-logout-button" (click)="logout.next()">
    <mat-icon>logout</mat-icon>
    <span>Log out</span>
  </button>
</div>

<!-- This template displays the overlay content and is connected to the button -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayDisableClose]="false"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isUserMenuOpen"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
      offsetX: -10,
      offsetY: 10
    }
  ]"
  cdkConnectedOverlayPanelClass="oiq-layout-account-panel"
  (backdropClick)="isUserMenuOpen = false"
  (overlayOutsideClick)="isUserMenuOpen = false">
  <div class="user-menu-overlay" *ngIf="account">
    <div class="user-menu-account-info"></div>
    <div class="user-menu-option-list">
      <div class="user-menu-option-list-item">
        <div class="account">
          <div class="avatar">
            {{ account.initials }}
          </div>
          <div class="account-info">
            <div class="name">
              {{ account.name }}
            </div>

            <div class="title">
              {{ camelToLabel(account.title) }}
            </div>
          </div>
        </div>
      </div>

      <hr />
      <!-- <div class="user-menu-option-list-item">
        <mat-icon>image</mat-icon>
        Themes
      </div>
      <div class="user-menu-option-list-item">
        <mat-icon>mail</mat-icon>
        Notification Settings
      </div>
      <div class="user-menu-option-list-item">
        <mat-icon>history</mat-icon>
        Change Log
      </div>
      <hr />
      <div class="user-menu-option-list-item">
        <mat-icon>info</mat-icon>
        Help & Info
      </div> -->
      <div class="user-menu-option-list-item" (click)="logout.next(); isUserMenuOpen = false">
        <mat-icon>logout</mat-icon>
        Log Out
      </div>
    </div>
  </div>
</ng-template>
